import { ChartDatapoint } from './chart-datapoint'

export class ChartTopic {
  constructor(
    public name: string,
    public series: ChartDatapoint[]
  ) {}
}
